// frontend/src/services/documentService.js
import axiosInstance from './axiosConfig'; // Your configured Axios instance

export const listDocuments = async (params = {}) => {
    try {
        const response = await axiosInstance.get('/documents', { params });
        return response.data; // Assuming the backend returns an array of documents
    } catch (error) {
        console.error('Error fetching documents:', error.response?.data || error.message);
        throw error.response?.data || new Error('Failed to fetch documents');
    }
};

export const uploadDocument = async (formData) => {
    try {
        const response = await axiosInstance.post('/documents/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Important for file uploads
            },
        });
        return response.data; // Should be { message: '...', document: newDocument }
    } catch (error) {
        console.error('Error uploading document:', error.response?.data || error.message);
        throw error.response?.data || new Error('Failed to upload document');
    }
};

export const getDownloadUrl = async (documentId) => {
    try {
        const response = await axiosInstance.get(`/documents/${documentId}/download`);
        return response.data; // Expected: { downloadUrl: '...', fileName: '...' }
    } catch (error) {
        console.error(`Error fetching download URL for document ${documentId}:`, error.response?.data || error.message);
        throw error.response?.data || new Error('Failed to get download URL');
    }
};

export const deleteDocument = async (documentId) => {
    try {
        const response = await axiosInstance.delete(`/documents/${documentId}`);
        return response.data; // Expected: { message: 'Document deleted successfully.' } or similar
    } catch (error) {
        console.error(`Error deleting document ${documentId}:`, error.response?.data || error.message);
        throw error.response?.data || new Error('Failed to delete document');
    }
};